import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    visibleTabs: [],
    activeTab: '',
    filterTypeQueueCounter: { id: 1, label: 'Campaign', value: 'Campaign' },
    filterTypeAgentList: { id: 3, label: "Group", value: "Group" },
    dashboardQueueFilters: [],
    dashboardAgentFilters: []
};

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        loading: (state, action) => {
            state.loading = action.payload;
        },
        addNewTab: (state, action) => {
            if (!state.visibleTabs.includes(action.payload)) {
                state.visibleTabs.push(action.payload);
            }
            state.activeTab = action.payload
        },
        removeTab: (state, action) => {
            const tabToDeleteIndex = state.visibleTabs.findIndex(tab => tab === action.payload);
            const updatedTabs = state.visibleTabs.filter((tab, index) => {
                return index !== tabToDeleteIndex;
            });
            state.visibleTabs = updatedTabs;
            if (state.activeTab === action.payload) {
                const previousTab = updatedTabs[tabToDeleteIndex - 1] || updatedTabs[tabToDeleteIndex + 1] || updatedTabs[0];
                state.activeTab = previousTab;
            }
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setVisibleTabs: (state, action) => {
            state.visibleTabs = action.payload
            if (action.payload.length > 0) {
                state.activeTab = action.payload[0];
            }
        },
        setDashboardFilters: (state, action) => {
            if (action.payload.type === 'agent') {
                state.dashboardAgentFilters = action.payload.filters;
            }
            else {
                state.dashboardQueueFilters = action.payload.filters;
            }
        },
        setFilterTypeQueueCounter(state, action) {
            state.filterTypeQueueCounter = action.payload;
        },
        setFilterTypeAgentList(state, action) {
            state.filterTypeAgentList = action.payload;
        }
    }
})

export const { setDashboardFilters, loading, addNewTab, removeTab, setActiveTab, setVisibleTabs, setFilterTypeQueueCounter, setFilterTypeAgentList } = dashboardSlice.actions;
export default dashboardSlice.reducer;